import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
import React from 'react';
import { FormHelperText as MuiFormHelperText } from '@material-ui/core';
export function FormHelperText(props) {
  return /*#__PURE__*/React.createElement(MuiFormHelperText, _extends({}, props, {
    role: props.error ? 'alert' : undefined
  }));
}